import React, { useContext } from "react";
import NavBar from "../../Components/NavBar";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import PrivacyTermsContent from "../../Components/PrivacyTermsContent/PrivacyTermsContent";
import { LanguageContext } from "../../Hooks/langugaeContext";

import { footnotesDataConst } from "../../constants/PrivacyTermsConst";
import { useTranslation } from "../../Hooks/useTranslation";

function Footnotes() {
  const translations = useTranslation();
  const { language, toggleLanguage } = useContext(LanguageContext);
  useAnimateOnScroll();
  return (
    <div>
      <NavBar onlyWhiteBg={true} />
      <PrivacyTermsContent
        title={translations.footnotesPageTitle}
        content={footnotesDataConst[language]}
      />
    </div>
  );
}

export default Footnotes;
